module.exports = __webpack_public_path__ + "static/img/LoadingBest.041b9bd.gif";


//////////////////
// WEBPACK FOOTER
// ./static/LoadingBest.gif
// module id = 9
// module chunks = 18